<template>
    <div class="row" v-if="imagepath">
        <div class="col-xl-5 order-xl-1 order-2 pt-5 pr-0 pb-0 pl-0">
            <div class="row">
                <div class="col-12 text-center" id="content-img-home">
                    <img class="img-fluid rounded-circle" :src="imagepath">
                </div>
            </div>

            <div class="row">
                <div class="col-xl-8 offset-xl-2 text-left px-4">
                    <div class="cormorantgaramond-italic" id="titledefinition" v-html="titledefinition"></div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-xl-8 offset-xl-2 text-left px-xl-5 px-4">
                    <div class="cormorantgaramond-light" id="definition" v-html="definition"></div>
                </div>
            </div>
        </div>

        <div class="col-xl-7 order-xl-2 order-1 pl-xl-0 pr-xl-5 px-4">
            <div class="h1-epk labgrotesque-bold" v-html="homecontent" @mouseover="setDefinition()"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "home",

    data() {
        return {
            homecontent: "",
            titledefinition: "",
            definition: "",
            terms: {},
            imagepath: null
        }
    },

    created() {
        axios.get("https://www.biswiss.ch/backend/api/homeimages", this.$root.auth)
        .then(response => {
            var images = response.data[0].field_immagini_home.split("|");
            var randomImg = this.$root.animejs.random(0, images.length - 1);
            this.imagepath = images[randomImg];
        });

        axios.get(this.$route.meta.api + "/" + this.$root.getLanguage(), this.$root.auth)
        .then(response => {
            var homecontent = "";
            var titledefinition = "";
            var definition = "";
            var terms = {};
            $.each(response.data, function(index, value) {
                if(value.sticky == 1) {
                    homecontent = value.body;
                }
            });

            $.each(response.data, function(index, value) {
                if(value.sticky == 0) {
                    homecontent = homecontent.replace(value.title, "<u class='terms cursor-pointer' data-title='" + value.title + "'>" + value.title + "</u>");
                    titledefinition = index === 1 ? value.title : titledefinition;
                    definition = index === 1 ? value.body : definition;
                    terms[value.title] = value.body;
                }
            });

            this.homecontent = homecontent;
            this.titledefinition = titledefinition;
            this.definition = definition;
            this.terms = terms;
        });
    },

    methods: {
        setDefinition() {
            var element = $(event.target);
            if(element.hasClass("terms")) {
                var title = element.attr("data-title");
                if(title != this.titledefinition) {
                    var thisObj = this;
                    var animation = this.$root.animejs.timeline({loop: false})
                    .add({
                        targets: '#titledefinition, #definition',
                        opacity: 0,
                        duration: 350,
                        easing: 'easeInOutQuad',
                        complete: function(anim) {
                            thisObj.titledefinition = title;
                            thisObj.definition = thisObj.terms[title];
                        }
                    })
                    .add({
                        targets: '#titledefinition, #definition',
                        opacity: [0, 1],
                        duration: 350,
                        easing: 'easeInOutQuad'
                    });
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/home.vue